import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import KidsCodePageHero from './KidsCodePageHero';
import kd1 from '../Images/kd1.jpg'
import kd2 from '../Images/kd2.jpg'
import kd3 from '../Images/kd3.jpg'
import kd0 from '../Images/kd0.png'
import { useNavigate } from 'react-router-dom';
import ProgramPricing from './ProgramPricing';

// Styled Components adhering strictly to the max 10px spacing rule and white background theme
const PageContainer = styled.div`
  background-color: #ffffff;
  color: #1a1a1a;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
  width: 100%;
  margin-top:50px;
`;

const NavSubMenu = styled.nav`
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  padding: 8px 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 5;
`;

const NavCategory = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #4f46e5;
`;

const NavLink = styled.a`
  color: #374151;
  text-decoration: none;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;

  &:hover {
    background: #4f46e5;
    color: #ffffff;
  }
`;

const Section = styled.section`
  padding: 10px;
  margin: 10px auto;
  max-width: 1200px;
`;

const HeroSection = styled(Section)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: 10px 10px;
`;

const Title = styled.h1`
  font-size: 32px;
  color: #111827;
  margin: 0 0 10px 0;
  line-height: 1.2;
  word-break: break-word;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #4b5563;
  margin: 0 0 10px 0;
  max-width: 700px;
  word-break: break-word;
`;

const Button = styled.button`
  background-color: #4f46e5;
  color: #ffffff;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  margin: 5px;
  transition: background 0.2s;

  &:hover {
    background-color: #4338ca;
  }
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 10px;
  margin: 10px 0;
  width: 100%;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 10px;
  margin: 10px 0;
`;

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  padding: 10px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CardTitle = styled.h3`
  font-size: 18px;
  color: #1f2937;
  margin: 0;
`;

const CardText = styled.p`
  font-size: 14px;
  color: #4b5563;
  margin: 0;
  word-break: break-word;
`;

const TestimonialCard = styled(Card)`
  background: #f9fafb;
  border-left: 4px solid #4f46e5;
`;

const SectionHeader = styled.h2`
  font-size: 26px;
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  margin: 12px 0;
  font-weight: 800;
  letter-spacing: -0.5px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.08));
`;

export default function KidsCodeAndTechPage() {
    const navigate = useNavigate();
  return (
    <PageContainer>
        <KidsCodePageHero/>
      {/* Sub-page Navigation Bar */}
      {/* <NavSubMenu>
        <NavCategory>Coding Programs:</NavCategory>
        <NavLink href="#coding-online">Kids Online Coding</NavLink>
        <NavLink href="#coding-summer">Summer Coding</NavLink>
        <NavLink href="#coding-easter">Easter Coding</NavLink>

        <NavCategory style={{ marginLeft: '10px' }}>AI Programs:</NavCategory>
        <NavLink href="#ai-summer">Summer AI for Kids</NavLink>
        <NavLink href="#ai-easter">Easter AI for Kids</NavLink>
        <NavLink href="#ai-weekend">Weekend AI Classes</NavLink>
      </NavSubMenu> */}

      {/* Hero Section */}
      <Fade triggerOnce>
        <HeroSection>
          <Title>
Coding Classes for Kids Who Build and Think Differently

          </Title>
          <Subtitle>
          We empower children ages 6 to 16 to master coding through fun, hands-on lessons that are easy to follow and genuinely enjoyable.  </Subtitle>
          <Button onClick={()=>navigate('/codingapplicationfaq')}>Enroll for Summer Classes</Button>
          <StyledImage src={kd0} alt="Kids coding online" />
        </HeroSection>
      </Fade>

  {/* About Section */}
      <Fade triggerOnce>
        <Section>
          <SectionHeader>About KidCodeAndTech</SectionHeader>
          <CardGrid>
            <Card>
              <CardTitle>Nigeria's Premier STEM Hub</CardTitle>
              <CardText>
                KidCodeAndTech Academy delivers cutting-edge programming and AI education tailored for children ages 6 to 16. Our immersive curriculum features engaging weekend classes, immersive holiday camps, and interactive STEM bootcamps.
              </CardText>
              <StyledImage src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=600&q=80" alt="Students learning" />
            </Card>
            <Card>
              <CardTitle>Inspiring 9,000+ Young Minds</CardTitle>
              <CardText>
            Our dedicated instructors have mentored more than 3,000 students across Nigeria and internationally, equipping them with essential competencies in Web Development, Mobile Apps, Game Design, Robotics, and Artificial Intelligence.
              </CardText>
              <StyledImage src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=600&q=80" alt="Happy students" />
            </Card>
          </CardGrid>
        </Section>
      </Fade>

  {/* Our Approach */}
      <Fade triggerOnce>
        <Section>
          <SectionHeader>Our Core Philosophy</SectionHeader>
          <CardText style={{ textAlign: 'center', marginBottom: '10px' }}>
            Coding is merely the foundation. We guide students to turn their technical capabilities into powerful tools for creative problem-solving and meaningful change.
          </CardText>
          <CardGrid>
            <Card>
              <CardTitle>Technical Mastery</CardTitle>
              <CardText>Building a strong foundation in modern digital tools and programming concepts to thrive in tomorrow's tech-driven economy.</CardText>
              {/* <StyledImage src="https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=600&q=80" alt="Technology setup" /> */}
            </Card>
            <Card>
              <CardTitle>Creative Innovation</CardTitle>
              <CardText>Encouraging outside-the-box thinking so students can apply their coding knowledge to address everyday challenges.</CardText>
              {/* <StyledImage src="https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=600&q=80" alt="Innovation workshop" /> */}
            </Card>
            <Card>
              <CardTitle>Entrepreneurial Thinking</CardTitle>
              <CardText>Nurturing a business-forward mindset that empowers youth to transform their unique ideas into impactful, real-world projects.</CardText>
              {/* <StyledImage src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=600&q=80" alt="Entrepreneurship kids" /> */}
            </Card>
          </CardGrid>
        </Section>
      </Fade>



   {/* Classroom in Action */}
      <Fade triggerOnce>
        <Section>
          <SectionHeader>Inside Our Learning Spaces</SectionHeader>
          <CardText style={{ textAlign: 'center' }}>
            Our sessions are dynamic, interactive, and entirely practical. We focus heavily on building real projects, fostering deep curiosity, and empowering students to embrace bold challenges with confidence.
          </CardText>
          <ImageGrid>
            <StyledImage src={kd1} />
          
            <StyledImage src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=500&q=80" alt="Classroom activity 3" />
            <StyledImage src={kd2} />
          </ImageGrid>
          <div style={{ textAlign: 'center', marginTop: '10px' }}>
            <Button onClick={()=>navigate('/codingapplicationfaq')}>Enroll Now</Button>
          </div>
        </Section>
      </Fade>

      {/* Featured Spotlight */}
      {/* <Fade triggerOnce>
        <Section>
          <SectionHeader>Our Students in the Global Spotlight</SectionHeader>
          <Card>
            <CardTitle>Featured on BBC Africa</CardTitle>
            <CardText>
              Our brilliant students were featured internationally on BBC Africa for engineering functional robots to solve everyday challenges—from automated garment folding to smart proximity sensing and obstacle removal.
            </CardText>
            <StyledImage src="https://images.unsplash.com/photo-1535378917042-10a22c95931a?auto=format&fit=crop&w=800&q=80" alt="Robotics and tech showcase" />
          </Card>
        </Section>
      </Fade> */}

{/* Core Programs */}
      <Fade triggerOnce>
        <Section>
          <SectionHeader>Our Flagship Offerings</SectionHeader>
          <CardGrid>
            <Card>
              <CardTitle>Coding & Software Development</CardTitle>
              <CardText>Mastering programming logic and syntax to equip children with the tools to tackle sophisticated digital challenges.</CardText>
              <StyledImage src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=600&q=80" alt="Coding program" />
            </Card>
            <Card>
              <CardTitle>Robotics & Hardware Engineering</CardTitle>
              <CardText>Exploring the mechanics of automated systems, electronics, and smart hardware within modern tech environments.</CardText>
              <StyledImage src="https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=600&q=80" alt="Robotics program" />
            </Card>
            <Card>
              <CardTitle>Artificial Intelligence & Machine Learning</CardTitle>
              <CardText>Introducing students to smart algorithms and intelligent software solutions designed for future-ready problem solving.</CardText>
              <StyledImage src={kd3} alt="AI program" />
            </Card>
            <Card>
  <CardTitle>UI/UX & Product Design</CardTitle>
  <CardText>Teaching students human-centered design principles, wireframing, and interactive prototyping to build intuitive digital experiences.</CardText>
  <StyledImage src="https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?auto=format&fit=crop&w=800&q=80" alt="UI/UX product design workspace" />
</Card>
          </CardGrid>
        </Section>
      </Fade>

      {/* Why Choose Us */}
      <Fade triggerOnce>
        <Section>
          <SectionHeader>Why Choose KidCodeAndTech?</SectionHeader>
          <CardGrid>
            <Card>
              <CardTitle>Stanford Design Thinking Framework</CardTitle>
              <CardText>We take learners through the core innovation phases: Empathy, Definition, Ideation, Prototyping, and Testing.</CardText>
            </Card>
            <Card>
              <CardTitle>Hands-On Project Execution</CardTitle>
              <CardText>Our curriculum links theoretical concepts directly to tangible projects, building critical thinking skills that last a lifetime.</CardText>
            </Card>
            <Card>
              <CardTitle>Passionate Expert Mentors</CardTitle>
              <CardText>Our talented tech educators bring energy, patience, and professional expertise to ensure every class is engaging and rewarding.</CardText>
            </Card>
          </CardGrid>
        </Section>
      </Fade>

{/* Testimonials */}
      <Fade triggerOnce>
        <Section>
          <SectionHeader>Parent Success Stories</SectionHeader>
          <CardGrid>
            <TestimonialCard>
              <CardText>"My son began learning at an early age and has grown tremendously. This is truly the way forward—enrolling him was one of our best choices ever!"</CardText>
              <CardTitle style={{ fontSize: '14px', color: '#4f46e5' }}>- Adriel's Dad</CardTitle>
            </TestimonialCard>
            <TestimonialCard>
              <CardText>"I was hesitant at first, but I was blown away by how well-organized and engaging the lessons are. My son gets excited for every single session."</CardText>
              <CardTitle style={{ fontSize: '14px', color: '#4f46e5' }}>- Gerald's Mum</CardTitle>
            </TestimonialCard>
            <TestimonialCard>
              <CardText>"All 3 of my kids joined the camp and instantly swapped hours of cartoons for building their own code. We couldn't be happier!"</CardText>
              <CardTitle style={{ fontSize: '14px', color: '#4f46e5' }}>- Eguono, Tega & Esiri's Mum</CardTitle>
            </TestimonialCard>
          </CardGrid>
        </Section>
      </Fade>

      {/* Mission Section */}
      <Fade triggerOnce>
        <Section style={{ textAlign: 'center', background: '#f8f9fa', padding: '20px', borderRadius: '6px' }}>
          <SectionHeader>Our Vision & Mission</SectionHeader>
          <Subtitle style={{ margin: '0 auto 10px auto' }}>
            As software, robotics, and artificial intelligence reshape our global landscape, our driving mission at KidCodeAndTech is to equip young innovators with the skills they need to lead tomorrow.
          </Subtitle>
          <Button onClick={()=>navigate('/codingapplicationfaq')}>Start Your Child's Journey</Button>
        </Section>
      </Fade>

      <ProgramPricing/>
    </PageContainer>
  );
}